import { useMutation } from '@tanstack/react-query';
import { postTransfer } from '../walletsService';

export interface usePosTransferVariables {
  txId: string;
  from?: string | undefined | null;
  to?: string | undefined | null;
  friendId?: string;
  referralId?: string;
  amount: number;
  isSelfTransfer: boolean;
}

export const usePostTransfer = () => {
  return useMutation({
    mutationFn: async ({ txId, from, to, friendId, referralId, amount, isSelfTransfer }: usePosTransferVariables) =>
      postTransfer({
        isSelfTransfer,
        txId,
        from,
        to,
        friendId,
        referralId,
        amount,
      }),
  });
};
